export function scrollToElement(element: HTMLElement | null): void {
    const offset = (element && element.offsetTop) || 0;
    window.setTimeout(() => window.scrollTo(0, offset));
}
